<template>
  <div class="main">
    <div class="title-bar row no-gutters">
      <div class="col-12 mb-4 col-lg-8 mb-lg-2">
        <h1 class="mb-2">{{ course.name }}</h1>
        <a class="btn-back" href="javascript:history.go(-1);">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Go Back</span>
        </a>
      </div>
      <div class="col-12 text-center pb-3 col-lg-4 text-lg-right pb-lg-0">
        <a
          v-if="!!course.can_request_event"
          class="btn btn-primary"
          href="#"
          @click.prevent="showRequestAnEvent()"
          >Request an Event</a
        >
      </div>
    </div>

    <div class="row no-gutters py-4">
      <div class="col-12 col-lg-6 mb-5 mb-lg-0">
        <div class="px-3 pl-xxl-4">
          <DetailsPane
            :course="course"
            title="Course Overview"
            section="registration"
            :hide-close="true"
            :auto-height="true"
            :hide-description="true"
            :hide-launch-button="false"
          />
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="px-4 px-lg-5 pt-lg-3">
          <h3 class="text-primary text-uppercase font-weight-bold mb-4">
            Course Description
          </h3>
          <div v-html="course.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsPane from "components/partials/Courses/DetailsPane";
import EventRequestCalendar from "./classroom/partials/EventRequestCalendar";

export default {
  components: { DetailsPane },

  props: {
    course: { type: Object, required: true },
  },

  methods: {
    showRequestAnEvent() {
      this.$modal(EventRequestCalendar, { course: this.course })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>